export default __webpack_public_path__ + "static/media/flag-italy-inactive.79dcd7a6.svg";